import { PurchaseOrderRepository } from "@domain/purchase-order/repositories/purchase-order.repository";
import { PurchaseOrderRepositoryService } from "../repositories/purchase-order.service";

export const PurchaseOrderProvider = [
    {
        provide: PurchaseOrderRepository,
        useClass: PurchaseOrderRepositoryService,
    },
];